import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertWarning16Icon extends BaseIcon {
  getChildren = () => [
    <path d="M15.84 13.85L9.25.78A1.38 1.38 0 007.4.14a1.35 1.35 0 00-.65.64L.16 13.85a1.53 1.53 0 000 1.44 1.41 1.41 0 001.25.71h13.18a1.41 1.41 0 001.21-.71 1.53 1.53 0 00.04-1.44zM7 4.83A.93.93 0 018 4a.93.93 0 011 .83v3.34A.93.93 0 018 9a.93.93 0 01-1-.83zM8 14a1.5 1.5 0 111.5-1.5A1.5 1.5 0 018 14z" fill="#ffb72d" fillRule="evenodd"/>
    ]
  getViewBox = () => '0 0 16 16'
}
